module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAASCAYAAACq26WdAAAABHNCSVQICAgIfAhkiAAAARJJREFUOE/N0rFRw0AQheF/ZUyKSzAVYAUcIVACKYONXIIrgQ64sTyk0AGORWDTASUo91jLoIBBkn13QsPApbe33+y+E354VgmDzZY7IDcps5A2ElJUr1klDDcFTyCj8k7VmpSpr1dr7PWGC41KaFBpHgC2wrIxCSIPeyfwgMFYNsGC3PpWpYVenS143lXnxcqPUPDylY9PQ/N+xHFsyeulTiy7ZsRBCVXz8YGqU5N+bqJ69mLefJygrs2cOAgLzcflmbk2BvFm5ttYm/sGVubU46hNk121/R5v9U/SxMYsETnvikmhl6cLlt/7/DmWqDDsOtlhhI0t787JuiKu9801TrhHOemMbpmZR9b/KrNf+40fKRFgE/4jTiwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/automode/中餐.png
// module id = 70
// module chunks = 7